import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
export const MyProfileBannerContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.backgroundGradientColor3.main,
  padding: '62px',
  paddingTop: '71px',

  '@media (max-width:1366px)': {
    paddingTop: '62px',
  },

  '@media (max-width:768px)': {
    paddingTop: '62px',
    paddingLeft: '64px',
  },

  '@media (max-width:414px)': {
    padding: '24px',
    paddingTop: '48px',
  },
}));

export const AlertInfoBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  position: 'fixed',
  top: '89px',
  left: 0,
  width: '100%',
  zIndex: 5,
}));

export const MyProfileBannerInfoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  flexDirection: 'column',
  className: 'my-profile-banner-info-box',
  '& .MuiButton-contained': {
    minWidth: 'unset',
    padding: '5px 24px',
  },
  '& .MuiButton-outlined': {
    minWidth: 'unset',
    padding: '5px 24px',
  },
}));

export const IconBannerInfoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '164px',
  height: '117px',
  padding: '8px 16px',
  border: '1px solid #D9D9D9',
  backgroundColor: '#ffffff',
  borderRadius: '10px',
  gap: theme.spacing(1),
  boxShadow: '0 2px  8px 0 rgba(0, 0, 0, 0.08)',
  cursor: 'pointer',
}));

export const MyProfileBoxWithoutBackground = styled(Grid)(({ theme }) => ({
  maxWidth: '1366px',
  width: '100%',
  marginInline: 'auto',
  paddingInline: '2.375rem',
  [theme.breakpoints.down('xl')]: {
    marginInline: 0,
    paddingInline: '3rem',
  },
  [theme.breakpoints.down(1150)]: {
    paddingInline: 0,
  },
}));
